import { FormatRupiah } from '@arismun/format-rupiah';
import dayjs from '../../utils/dayjs';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import { getUserColor } from '../../utils/color';
import { logError } from '../../utils/errorHandler';

const ItemTransaction = ({date,listRaw,transactions,book,onDelete}) => {
    const d = dayjs(date);
    const transc = transactions;
    const navigate = useNavigate();

    const [debit, setDebit] = useState('');
    const [kredit, setKredit] = useState('');

    const [modalItemTrnsc, setModalTrnsc] = useState(null);

    useEffect(() => {
        countDebitKredit();
        //setDate(date);
    }, []);

    const countDebitKredit = () => {
        let d = 0;
        let k = 0;
        transc.forEach(item => {
            if (item.type === 'debit') {
                d += parseInt(item.amount);
            } else {
                k += parseInt(item.amount);
            }
        })
        setDebit(d);
        setKredit(k);
    }

    const editTransaction = (transaction) => {
        console.log(book);
        navigate('/transaction/add', {
            state: {
                transaction: transaction,
                action: 'edit',
                type: transaction.type
            }
        })
    }

    const arrayTransId = (arr) => arr.map(x => x.id);

    const deleteTransaction = async (item) => {
        //e.preventDefault()
        const transId = arrayTransId(listRaw)

        try {
            await api.post('/transaction/delete', {
                transaction_id: item.id,
                category_id: item.category_id
            })

            // delete list if success delete in server
            const index = transId.indexOf(item.id);
            console.log(transId.indexOf(item.id));
            if (index > -1) {
                listRaw.splice(index, 1)
            }
            onDelete(listRaw);
            setModalTrnsc(null);
        } catch (error) {
            logError('Gagal menghapus transaksi:', error);
        }
    }

    return (
        <div className='card p-4 mb-3'>
            <div className='is-clearfix mb-3'>
                <div className='date-icon is-pulled-left'>{d.format('D')}</div>
                <div className='is-pulled-left'>
                    <p className='is-size-7'>{d.format('dddd')}</p>
                    <p className='is-size-7'>{d.format('MMM, YYYY')}</p>
                </div>
                <div className='is-pulled-right has-text-right'>
                    <div className='is-size-7'><FormatRupiah value={debit} /></div>
                    <div className='is-size-7'>- <FormatRupiah value={kredit} /></div>
                </div>
            </div>
            <hr className='mt-2 mb-3' />
            {transc.map((sub, subindex) =>
                <div key={subindex}>
                    <div className='transaction-item is-clickable' onClick={() => setModalTrnsc(subindex)}>
                        <div className="user-avatar" style={{backgroundColor: getUserColor(sub.name)}}>
                            {sub.name ? sub.name.charAt(0).toUpperCase() : '?'}
                        </div>
                        <div className='transaction-item-content'>
                            <div className='transaction-item-header'>
                                <p className='is-size-6 transaction-item-category'>{sub.category}</p>
                                <div className={`transaction-item-amount is-${sub.type}`}>
                                    {sub.type === 'kredit' && '- '}<FormatRupiah value={sub.amount} />
                                </div>
                            </div>
                            <p className='is-size-7'>{sub.note}</p>
                        </div>
                    </div>

                    {/* modal transaction */}
                    <div className={`modal p-5 ${(modalItemTrnsc === subindex) ? 'is-active' : ''}`}>
                        <div className="modal-background"></div>
                        <div className="modal-content card">
                            <header className='card-header'>
                                <p className="card-header-title">{sub.type}</p>
                                <button className="card-header-icon" onClick={() => setModalTrnsc(null)}>
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </header>
                            <div className='card-content'>
                                
                                <div className='is-clearfix'>
                                    <span className='is-pulled-left'>Jumlah</span>
                                    <span className='is-pulled-right'><FormatRupiah value={sub.amount} /></span>
                                </div>
                                <hr className='mt-2 mb-2'/>
                                <div className='is-clearfix'>
                                    <span className='is-pulled-left'>Catatan</span>
                                    <span className='is-pulled-right'>{sub.note}</span>
                                </div>
                                <hr className='mt-2 mb-2'/>
                                <div className='is-clearfix'>
                                    <span className='is-pulled-left'>Kategori</span>
                                    <span className='is-pulled-right'>{sub.category}</span>
                                </div>
                                <hr className='mt-2 mb-2'/>
                                <div className='is-clearfix'>
                                    <span className='is-pulled-left'>Dompet</span>
                                    <span className='is-pulled-right'>{sub.pocket}</span>
                                </div>
                                <hr className='mt-2 mb-2'/>
                                <div className='is-clearfix'>
                                    <span className='is-pulled-left'>Tanggal</span>
                                    <span className='is-pulled-right'>{dayjs(sub.date).format('D MMM YYYY')}</span>
                                </div>
                                <hr className='mt-2 mb-2'/>
                                <div className='is-clearfix'>
                                    <span className='is-pulled-left'>Waktu</span>
                                    <span className='is-pulled-right'>{sub.time ? sub.time : '-'}</span>
                                </div>
                                <hr className='mt-2 mb-2'/>
                                <div className='is-clearfix'>
                                    <span className='is-pulled-left'>Oleh</span>
                                    <span className='is-pulled-right'>{sub.name}</span>
                                </div>
                            </div>
                            <footer className='card-footer'>
                                <button className='card-footer-item has-text-danger'
                                    onClick={()=>{deleteTransaction(sub); }}>
                                    Delete
                                </button>
                                <button className='card-footer-item '
                                    onClick={() => editTransaction(sub)}>
                                    Edit
                                </button>
                            </footer>
                        </div>

                    </div>

                </div>
            )}
        </div>
    )
}

export default ItemTransaction
